import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GateWay } from '../gateway.model';

export enum GateWayTrapActionTypes {
  UpsertMgtTrapDetail = '[GateWay] Upsert Mgt Trap Detail',
  ReadMgtTrapDetail = '[GateWay] Read Mgt Trap Detail',
  ReadMgtTrapDetailFail = '[GateWay] Read Mgt Trap Detail Fail',
  UpsertTrapDetail = '[GateWay] Upsert Trap Detail',
  ReadTrapDetail = '[GateWay] Read Trap Detail',
  ReadTrapDetailFail = '[GateWay] Read Trap Detail Fail',
  AddMgtTrapDetail = '[GateWay] Add Mgt Trap Detail',
  UpdateMgtTrapDetail = '[GateWay] Update Mgt Trap Detail',
  DeleteMgtTrapDetail = '[GateWay] Delete Mgt Trap Detail',
}
export class ReadMgtTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.ReadMgtTrapDetail;

  constructor(public payload: any = null) {}
}
export class UpsertMgtTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.UpsertMgtTrapDetail;

  constructor(public payload: any) {}
}
export class ReadMgtTrapDetailFail implements Action {
  readonly type = GateWayTrapActionTypes.ReadMgtTrapDetailFail;

  constructor(public payload: any = null) {}
}
export class ReadTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.ReadTrapDetail;

  constructor(public payload: any = null) {}
}
export class UpsertTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.UpsertTrapDetail;

  constructor(public payload: any) {}
}
export class ReadTrapDetailFail implements Action {
  readonly type = GateWayTrapActionTypes.ReadTrapDetailFail;

  constructor(public payload: any = null) {}
}
export class AddMgtTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.AddMgtTrapDetail;

  constructor(public payload: any = null) {}
}
export class UpdateMgtTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.UpdateMgtTrapDetail;

  constructor(public payload: any = null) {}
}
export class DeleteMgtTrapDetail implements Action {
  readonly type = GateWayTrapActionTypes.DeleteMgtTrapDetail;

  constructor(public payload: any = null) {}
}



export type GateWayTrapActions =
UpsertMgtTrapDetail
 | ReadMgtTrapDetail
 | ReadMgtTrapDetailFail
 | UpsertTrapDetail
 | ReadTrapDetail
 | ReadTrapDetailFail
 | AddMgtTrapDetail
 | UpdateMgtTrapDetail
 | DeleteMgtTrapDetail
